import { render, staticRenderFns } from "./SkeletonRow.vue?vue&type=template&id=ccccd850&"
import script from "./SkeletonRow.vue?vue&type=script&lang=js&"
export * from "./SkeletonRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports